export default (newPaymentFormData) => {
  const requestData = {
    name: newPaymentFormData?.bankName,
    country: newPaymentFormData?.bankCountry,
    bic: newPaymentFormData?.bic
  };

  // Add paymentPurpose as 'purpose' for UAE
  if (newPaymentFormData?.bankCountry === 'AE' && newPaymentFormData?.paymentPurpose) {
    requestData.paymentPurpose = newPaymentFormData.paymentPurpose;
  }

  return requestData;
};
